module.exports = __webpack_public_path__ + "media/images/rank-3-fff1ca1ff42a57f964b71a2c2582c73a.svg";